import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Form } from 'semantic-ui-react'
import { IndividualFiltersService } from '~/api/services/individualFilters'
import { FormFields } from '~/components/FormFields'
import Layout from '~/components/Layout'
import { El } from '~/components/Layout/style'
import notify from '~/components/Notify'
import { RouteTypes } from '~/routes/constants'
import { getYearsOptions, handleErrors } from '~/utils/helpers'

const CreateEditAmFilter: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { id } = useParams()

  const [isBusy, setIsBusy] = useState(false)

  const { control, handleSubmit, reset, watch } = useForm({
    mode: 'onSubmit'
  })

  const watchAmountFrom = watch('amountFrom')

  useEffect(() => {
    if (id) {
      fetchData()
    }
  }, [id])

  async function fetchData() {
    setIsBusy(true)
    try {
      const response = await IndividualFiltersService.filtersAmountEdit(id)
      reset(response.data)
    } catch (error) {
      handleErrors(error)
    } finally {
      setIsBusy(false)
    }
  }

  function renderActions() {
    return <>
      <El.PageHeaderActionButton type='submit'
        disabled={isBusy}
        loading={isBusy}>{t('Save')}</El.PageHeaderActionButton>
      <El.PageHeaderActionButton
        type='button'
        onClick={() => navigate(RouteTypes.DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_AMOUNT)}
      >{t('Cancel')}</El.PageHeaderActionButton>
    </>
  }

  async function onSubmit(data) {
    setIsBusy(true)
    try {
      if (id) {
        await IndividualFiltersService.filtersAmountUpdate(id, data)
        notify(t('Successfully updated amount filter'), 'success')
      } else {
        await IndividualFiltersService.filtersAmountStore(data)
        notify(t('Successfully created amount filter'), 'success')
      }
      navigate(RouteTypes.DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_AMOUNT)
    } catch (error) {
      handleErrors(error)
    } finally {
      setIsBusy(false)
    }
  }

  function renderForm() {
    return <>
      <FormFields.Input
        control={control}
        name={'name'}
        placeholder={t('Enter name')}
        rules={{
          required: t('Please enter name!'),
          maxLength: {
            value: 150,
            message: t('Max char. length is 150!')
          }
        }}
        label={t('Name')}
      />
      <Form.Group widths={'equal'}>
        <FormFields.Input
          control={control}
          name={'amountFrom'}
          typeInput={'controled'}
          placeholder={t('Amount from')}
          rules={{
            required: t('Please enter amount!'),
            min: {
              value: 0,
              message: t('Please enter value greater or equal to 0')
            }
          }}
          label={t('Amount from')}
        />
        <FormFields.Input
          control={control}
          name={'amountTo'}
          placeholder={t('Amount to')}
          typeInput={'controled'}
          rules={{
            required: t('Please enter amount!'),
            min: {
              value: watchAmountFrom,
              message: t('Please enter value greater then amount from!')
            },
            max: {
              value: 100000000,
              message: t('Please enter value less then 100.000.000!')
            }
          }}
          label={t('Amount to')}
        />
      </Form.Group>
      <div style={{ minHeight: '15em' }}>
        <FormFields.Select
          placeholder={t('Select year')}
          label={t('Year')}
          search
          maxHeightMenu={'9em'}
          rules={{
            required: {
              value: true,
              message: t('Please select a year!')
            }
          }}
          selectOnBlur={false}
          control={control}
          options={getYearsOptions()}
          name={'year'}
        />
      </div>
    </>
  }

  return <Layout
    title={id ? t('Edit amount filter') : t('Create amount filter')}
    onSubmit={handleSubmit(onSubmit)}
    fontSizeHeader={'18px'}
    childContainerSize={'300px'}
    isBusy={isBusy}
    actions={renderActions()}
  >
    {renderForm()}
  </Layout>
}
export default CreateEditAmFilter